module.exports = __webpack_public_path__ + "img/icon-xiangqufill.9c62507b.svg";